const UserSettings = () => import('@/modules/userSettings');
const CreateUser = () => import('@/modules/userSettings/_components/CreateUser');

export default [
  {
    path: '/configuracoes/usuarios',
    name: 'list-users',
    component: UserSettings,
    meta: {
      navbarTitle: 'Usuários',
      isAvaliableInMenu: true,
      menuData: {
        title: 'Usuários',
        id: 'listUser',
        section: 'Configurações',
        icon: 'user-2',
      },
      permissions: [
        'READ_USER',
        'CREATE_USER',
      ],
    },
  },
  {
    path: '/configuracoes/usuarios/criar',
    name: 'user-create',
    component: CreateUser,
    meta: {
      navbarTitle: 'Criar usuário',
      permissions: [
        'CREATE_USER',
      ],
    },
  },
];
